import React from "react";
import PackingCalculatorApp from "./PackingCalculatorApp";
import "./index.css"; // Tailwind CSS

function App() {
    return (
        <div className="App">
            <PackingCalculatorApp />
        </div>
    );
}

export default App;
